export enum WithdrawalMethodType {
  BANK = 'bank',
}
